export default __webpack_public_path__ + "static/media/dom-tree-illustration.8447c079.png";